module.exports = __webpack_public_path__ + "img/ic_done_nor.b796cd1e.svg";